import { apiClient } from './client';
import type { HostStatsSummary } from '../types';

export const hostApi = {
  async getSummary(): Promise<HostStatsSummary> {
    const { data } = await apiClient.get<HostStatsSummary>('/host/summary');
    return data;
  },
};
